var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',{staticClass:"px-6 pt-0 d-flex justify-end dialog-card-actions"},[_c('v-btn',{staticClass:"px-4 d-flex align-center simple-button",class:{
      'pr-2': _vm.isShowMode
    },attrs:{"color":"primary","plain":"","ripple":false},on:{"click":_vm.close}},[_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.isShowMode ? 'Закрыть' : 'Отмена'))])]),(!_vm.isShowMode)?_c('v-btn',{staticClass:"px-4 d-flex align-center",attrs:{"color":"primary","loading":_vm.saveBtnLoading,"disabled":_vm.isShowMode || _vm.isInvalid},on:{"click":_vm.save}},[_c('v-icon',{staticClass:"uikit-icon pen size-20 white",class:{
        greylighten1: _vm.isShowMode || _vm.isInvalid,
        send: _vm.isSend && !_vm.isEdit,
        save: _vm.isEdit,
        'size-16': _vm.isSend,
        'mb-1px': _vm.isEdit
      }}),_c('span',{staticClass:"pl-1 btn-text"},[_vm._v(" "+_vm._s(_vm.isSend ? 'Отправить' : _vm.isEdit ? 'Сохранить' : 'Создать')+" ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }